const howtoworks = [
    {
        "id": 0,
        "name": "HOW IT WORKS",
        "title": "Multi-layered access control ensures–",
        "img": "blockchain-technology-to-ensure-transparency-security-reliability.png",
        "list": [
            { "id": 0, "desc": "Enhanced Data Security: Our multi-layered access control system ensures data security by empowering HR to regulate access rights, safeguarding sensitive information with precision and reliability." },

            { "id": 1, "desc": "Role-Specific Precision: HR professionals can define roles with accuracy using our system, assigning permissions that align perfectly with team responsibilities for efficient and secure operations." },

            { "id": 2, "desc": "Seamless Permission Management: The advanced access control feature simplifies permission management, allowing HR to assign and adjust team-specific access rights effortlessly, ensuring smooth and secure workflows." },

            { "id": 3, "desc": "Empowering HR Control: Our system empowers HR to manage access rights with precision, ensuring secure data handling and clear role definitions for streamlined team operations and compliance." }
        ]
    },
    {
        "id": 1,
        "name": "HOW IT WORKS",
        "title": "Payroll made simplified and more dynamic thorough-",
        "img": "payroll-made-easier-with-smartpeople.png",
        "list": [
            { "id": 0, "desc": "Automated Payroll Processing: Auto calculate and process employee salaries, deductions, and taxes with accuracy in just one click." },

            { "id": 1, "desc": "Compliance and Tax Management: Ensure regulatory compliance by automating tax calculations, deductions, and generating tax during payroll processing." },

            { "id": 2, "desc": "Self-Service Payslips: Empower workforce with secure access to digital payslips, enabling them to conveniently view and download their payment and deduction details whenever needed." },

            { "id": 3, "desc": "Integration with Time and Attendance Device: Seamlessly sync attendance data to automate payroll calculations, reducing manual data entry and minimizing potential errors." },

            { "id": 4, "desc": "Customized Payroll Reports: Generate comprehensive payroll reports with customizable parameters, offering valuable insights to support informed decision-making."}
        ]
    },
    {
        "id": 2,
        "name": "HOW IT WORKS",
        "title": "People management made easier through—",
        "img": "people-management-made-easier-with-SmartPeople.png",
        "list": [
            { "id": 0, "desc": "Employee Profile Management: Create and maintain employee profiles with necessary information, contact details, and employment history." },

            { "id": 1, "desc": "Performance Tracking and Reviews: Streamline performance management by setting goals, conducting regular performance reviews, and tracking employee progress." },

            { "id": 2, "desc": "Training and Development: Facilitate employee growth and skill enhancement through centralized training management, including scheduling, tracking, and reporting." },

            { "id": 3, "desc": "Leave and Attendance Tracking: Simplify leave requests, approvals, and tracking, while seamlessly integrating with attendance records for accurate time management." },

            { "id": 4, "desc": "Document Management: Store and manage employee documents, such as contracts, certifications, and appraisal records, in a secure digital repository."}
        ]
    },

    {
        "id": 3,
        "name": "HOW IT WORKS",
        "title": "Dynamic Workflow Automation",
        "img": "dynamic-workflow-automation.png",
        "list": [
            { "id": 0, "desc": "SmartPeople revolutionizes workflow management with its dynamic approach, adapting to your organization's ever-changing needs effortlessly." },

            { "id": 1, "desc": "With SmartPeople's dynamic workflow management, you can easily design, modify, and optimize processes in real-time, ensuring maximum efficiency and productivity." },

            { "id": 2, "desc": "Experience unparalleled agility in your HR operations as SmartPeople's dynamic workflow management empowers you to respond quickly to evolving business requirements." },

            { "id": 3, "desc": "SmartPeople's dynamic workflow management adapts to varying complexities, streamlining tasks and approvals, resulting in a seamless and error-free workflow." },

            { "id": 4, "desc": "Embrace the future of HR with SmartPeople's intelligent dynamic workflow management, making your processes flexible, responsive, and tailored to your organization's unique demands."}
        ]
    }
]

export default howtoworks;